import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UserWVO} from '../models/UserWVO';
import { EnvironmentService } from 'src/app/services/environment.service';

const API_ENTRY_POINT = '/ws/rest/';

@Injectable({
  providedIn: 'root',
})
export class AffichageCGUService {

  constructor(private readonly http: HttpClient, private environmentService: EnvironmentService) { 
  }

  getConnectedUser(): Observable<UserWVO> {
    return this.http.get<UserWVO>(`${this.environmentService.get().serverUrl}${API_ENTRY_POINT}users/getConnectedUserInfo`);
  }

  getPdf(typeDocument: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('typeDocument', typeDocument);
    return this.http.get<any>(`${this.environmentService.get().serverUrl}${API_ENTRY_POINT}rgpdPdf/getdocumentrgpd`, {
      responseType: 'arraybuffer' as 'json',
      params: queryParams
    });
  }


  getStatusCgu(typeDocument: string): Observable<number> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('typeDocument', typeDocument);
    return this.http.get<number>(`${this.environmentService.get().serverUrl}${API_ENTRY_POINT}users/StatusCgu`, {params: queryParams});
  }

  updateStatusCgu(statusCgu: boolean): Observable<UserWVO> {
    return this.http.post<UserWVO>(`${this.environmentService.get().serverUrl}${API_ENTRY_POINT}users/Update/StatusCguUser`, statusCgu);

  }

  getDocumentsRgpdByCompanySite(): Observable<any> {
    return this.http.get<any>(`${this.environmentService.get().serverUrl}${API_ENTRY_POINT}rgpdPdf/getDocumentsRgpdByCompanySite`);
  }
}
